import { render, staticRenderFns } from "./QRReceipt.vue?vue&type=template&id=78c4db46&scoped=true&"
import script from "./QRReceipt.vue?vue&type=script&lang=js&"
export * from "./QRReceipt.vue?vue&type=script&lang=js&"
import style0 from "./QRReceipt.vue?vue&type=style&index=0&id=78c4db46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c4db46",
  null
  
)

export default component.exports